/* Batch 20 · F-153 (B1): the confidence level, any level from 25 % to 100 %, whole or one decimal, typed as a percentage.
   PR 58 / 59 FIXES · F3 (Stage 1 · A-23 screen): it starts EMPTY — there is no default level; the placeholder asks the auditor to
   choose and the inline message (error key from confidencePctError) says it must be chosen. Moved out of Sampling.jsx (a file
   over 1,500 lines gets new code in a new component). */
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ConfidenceField({ value, onChange, error, t, children }) {   // STEP 7e-2: children = the firm minimum note
  return (
    <div>
      <Label>{t("sampling.confidence")}</Label>
      <div className="flex items-center gap-1">
        <Input type="number" inputMode="decimal" min={25} max={100} step={0.1} dir="ltr"
               value={value}
               onChange={(e) => onChange(e.target.value)}
               placeholder={t("fxA.sampling.confidencePlaceholder")}
               aria-invalid={!!error}
               data-testid="samp-conf" className="w-28" />
        <span className="text-sm text-muted-foreground">%</span>
      </div>
      <div className="mt-0.5 text-[10px] text-muted-foreground" data-testid="samp-conf-min">{t("s7a.minConfidence")}</div>
      {error && (
        <div className="mt-0.5 text-[11px] text-red-600" data-testid="samp-conf-error">
          {t(error)}
        </div>
      )}
      {children}
    </div>
  );
}
